import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { ourValue } from '../../../../routes/ourValue'
import styles from './styles.module.scss'
import SwiperCore, { Pagination } from 'swiper'
import parse from "html-react-parser";
SwiperCore.use([Pagination]);
const WhyGenerium = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>Наши ценности</p>
        </div>

        <div className={styles.slider}>
          <Swiper
            // pagination={true}
            spaceBetween={16}
            slidesPerView={3}
            initialSlide={0}
            // loop={true}
            // speed={5000}
            // autoplay={{
            //   delay: 3000
            // }}
            // modules={[Autoplay]}
            breakpoints={{
              1440: {
                slidesPerView: 3
              },
              1365: {
                slidesPerView: 3
              },
              1025: {
                slidesPerView: 2.3,
                spaceBetween: 24
              },
              769: {
                slidesPerView: 2.5,
                spaceBetween: 16
              },
              686: {
                slidesPerView: 3,
                spaceBetween: 16
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 16
              },
              380: {
                slidesPerView: 1.5,
                spaceBetween: 16
              },
              320: {
                slidesPerView: 1.3,
                spaceBetween: 16
              }
            }}
          >
            {ourValue !== undefined ?
              ourValue
                .filter((elem, i) => i < 20)
                .map((item, index) => (
                  <>
                    <SwiperSlide key={item.id}>
                      <div className={styles.slider_item}>
                        <div className={styles.slider_item_inner}>
                          <div className={styles.slider_item_front}>
                            <p className={styles.slider_item_p1}>{item.title}</p>
                            <img src={item.img} alt='icons' draggable='false'/>
                          </div>
                          <div className={styles.slider_item_back}>
                            <p className={styles.slider_item_p2}>{parse(item.text)}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide></>
                )) : ""}
           </Swiper>
        </div>
      </div>
    </div>
  )
}

export default WhyGenerium
